export default "__VITE_ASSET__924a0317__"